<template>
  <div class="grid-faq px-sm-3 px-md-5">
    <template v-if="posts.length">
      <faq-card
        v-for="post in posts"
        :key="post.id"
        :title="post.title"
        :content="post.content"
        :topic="post.topic"
        @onClickTag="(topic) => $emit('onClickTopicTag', {topic})"
      />
    </template>
    <article v-else>
      <h2 class="text-muted text-center">
        Hello, for the moment there are no posts, we hope to answer your problem in the future.
      </h2>
    </article>
  </div>
</template>
<script>
import FaqCard from '@/components/faq/FaqCard.vue';
export default {
  components: {
    FaqCard,
  },
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped>
.grid-faq {
  display: grid;
  margin-top: 2rem;
  gap: 2rem;

  @media screen and (min-width: 1025px) {
    padding: 0 5rem !important;
  }
}
</style>
